import * as Yup from "yup"

export const SDCompaniesInitialValues = {
	name: "",
}

export const SDCompaniesSchema = Yup.object().shape({
	name: Yup.string().required().label("Name"),
})
